import { Navigate, RouteObject } from "react-router";
import ManageBuildingRoute from "@/routes/processes/[processId]/qpm/manage-building/manage-building-route";
import RequirementsRoute from "@/routes/processes/[processId]/qpm/requirements/requirements-route";
import { requirementRoutes } from "@/routes/processes/[processId]/qpm/requirements/requirement-routes";
import CalculationsRoute from "@/routes/processes/[processId]/qpm/calculations/calculations-route";
import { calculationsRoutes } from "@/routes/processes/[processId]/qpm/calculations/calculations-routes";
import OffersMainNavRoute from "@/routes/processes/[processId]/qpm/offers/offers-main-nav-route";
import { offersRoutes } from "@/routes/processes/[processId]/qpm/offers/routes";
import { OverviewRoute } from "@/routes/processes/[processId]/qpm/overview/overview-route";

export const qpmRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="manage-building" replace />,
  },
  {
    path: "overview",
    element: <OverviewRoute />,
  },
  {
    path: "manage-building",
    element: <ManageBuildingRoute />,
  },
  {
    path: "requirements",
    element: <RequirementsRoute />,
    children: requirementRoutes,
  },
  {
    path: "calculations",
    element: <CalculationsRoute />,
    children: calculationsRoutes,
  },
  {
    path: "offers",
    element: <OffersMainNavRoute />,
    children: offersRoutes,
  },
];
